import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogContent, TextField } from '@mui/material';
import { getCurrentIdentity, isTelegramEnvironment } from '../userIdentity';

const TelegramLinkButton = () => {
  const [visible, setVisible] = useState(false);
  const [clientId, setClientId] = useState('');
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState('');
  const [text, setText] = useState('');
  const [polling, setPolling] = useState(false);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      if (isTelegramEnvironment()) return;

      const identity = await getCurrentIdentity();

      if (!mounted) return;

      setClientId(identity.clientId);
      setVisible(!identity.linked);
    };

    load();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (!polling || !clientId) return;

    const timer = setInterval(async () => {
      const identity = await getCurrentIdentity();

      if (identity.linked) {
        clearInterval(timer);
        window.location.reload();
      }
    }, 2500);

    return () => clearInterval(timer);
  }, [polling, clientId]);

  const handleSubmit = async () => {
    setText('');

    const response = await fetch('/api/telegram-link/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientId, target })
    });

    if (!response.ok) {
      setText('Не найдено');
      return;
    }

    setPolling(true);
    setOpen(false);
  };

  if (!visible) return null;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          right: 12,
          top: 12,
          zIndex: 3000,
        }}
      >
        <Button
          variant="contained"
          size="small"
          onClick={() => setOpen(true)}
          sx={{
            borderRadius: '14px',
            backgroundColor: '#2a2a2a',
            color: '#fff',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          Привязать телеграмм
        </Button>
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <DialogContent sx={{ backgroundColor: '#121212' }}>
          <TextField
            autoFocus
            fullWidth
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            placeholder="Введите свой айди или юз"
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSubmit();
            }}
          />

          {!!text && (
            <Box sx={{ color: '#fff', mt: 2 }}>
              {text}
            </Box>
          )}

          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{ mt: 2 }}
          >
            Привязать
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TelegramLinkButton;